import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import collectionReducer from './collectionSlice';
import detailReducer from './detailSlice';
import dictReducer from './dictSlice';
import mainSlice from './mainSlice';
import notiReducer from './notiSlice';
import priceReducer from './priceSlice';

export const store = configureStore({
    reducer: {
        main: mainSlice,
        price: priceReducer,
        noti: notiReducer,
        detail: detailReducer,
        dict: dictReducer,
        collection: collectionReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
